<template>
  <i class="ri-question-line" @mouseenter="(e) => showOverlay(e)" @mouseleave="hideOverlay"></i>
</template>

<script setup lang="ts">
import { useStore } from 'vuex';

const props = defineProps<{
  /** Text content of the overlay panel */
  text: string;
}>();

const store = useStore();

const showOverlay = (event: MouseEvent) => {
  store.commit('layout/SET_OVERLAY', { text: props.text, triggeringEvent: event });
};

const hideOverlay = () => {
  store.commit('layout/SET_OVERLAY', {});
};
</script>

<style scoped>
i {
  cursor: help;
}
</style>
